import { type HttpClientConfig } from 'core/infra/http/HttpClient'

import sentry from 'legacy/utils/sentry'

import { isOnPortalLinkRoute } from 'rate-command-center/infra/isOnPortalLinkRoute'

import { createAgnosticHttpClient } from '../infra/createAgnosticHttpClient'
import { createMagicLinkHttpClient } from '../infra/createMagicLinkHttpClient'
import {
  InviteTokenRepository,
  type RefreshInviteTokenParams,
} from '../infra/InviteTokenRepository'

export type RefreshInviteTokenFactoryDependencies = {
  repository: InviteTokenRepository
}

export function refreshInviteTokenFactory({ repository }: RefreshInviteTokenFactoryDependencies) {
  return async function refreshInviteToken(
    params: RefreshInviteTokenParams,
    config?: Partial<HttpClientConfig>
  ) {
    try {
      return await repository.refreshToken(params, config)
    } catch (error) {
      const refreshError = new Error('Could not refresh the carrier invite token', {
        cause: error as Error,
      })

      sentry.log(refreshError)

      throw refreshError
    }
  }
}

export function refreshInviteToken(
  params: RefreshInviteTokenParams,
  config?: Partial<HttpClientConfig>
) {
  // On /portal-link/* the expired token is the magic-link one, not the invite token.
  const httpClient = isOnPortalLinkRoute()
    ? createMagicLinkHttpClient()
    : createAgnosticHttpClient()
  const repository = new InviteTokenRepository({ httpClient })
  const refresh = refreshInviteTokenFactory({ repository })

  return refresh(params, config)
}
